export default __webpack_public_path__ + "static/media/calendar.281c130f.svg";